import React from 'react'

import { useLanguages } from '@/hooks'

export const Header: React.FC = () => {
  const { t } = useLanguages()
  return (
    <div className="cover">
      <h1 className="blue-color">{t('faqTitle')}</h1>
      <div></div>
    </div>
  )
}
